import { useState, useEffect } from "react";
import { Outlet, Link, useLoaderData, NavLink } from "react-router-dom";
import Select from 'react-select'
// import "antd/dist/antd.css";
import { Table } from "antd";
import { CSVLink } from "react-csv";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import Spinner from './Spinner';

import * as API from "../services/listados";
import * as APIESPECIALISTAS from "../services/especialistas";

export async function loader() {
  // const pacientes = await API.getAllPacientes();
  // return { pacientes };
}

export function ListadoAdminPacientes() {


  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Data');


  const [loading, setLoading] = useState(false);

  const [listadoResult, setListadoResult] = useState("");
  const [columns, setColumns] = useState([]);
  const [columnsExcel, setColumnsExcel] = useState([]);

  const submitListado = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.getListadoPacientes(
      ).then(
        (val) => {
          setListadoResult(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };



  useEffect(() => {
    if (listadoResult.length > 0) {
      // Obtenemos las claves de la primera fila para usarlas como nombres de columna
      const keys = Object.keys(listadoResult[0]);
    
      const newColumns = keys.map(key => ({
        title: key,
        dataIndex: key,
        key: key,
        // width: 100
      }));
    
      setColumns(newColumns);

      const newColumnsExcel = keys.map(key => ({
        header: key,
        key: key,
        width: 15
      }));
      
      setColumnsExcel(newColumnsExcel);

    }
  }, [listadoResult]);

  const convertToDate = (dateStr) => {
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`);
  };

  // Función para exportar a Excel
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');

    // Añadir las columnas al archivo Excel (asumiendo que columnsExcel es el estado que contiene las columnas)
    worksheet.columns = columnsExcel;

    listadoResult.forEach(objeto => {
      const newObj = { ...objeto };
      if (newObj.Tratamiento) {
        newObj.Tratamiento = convertToDate(newObj.Tratamiento);
      }
      if (newObj.Fecha) {
        newObj.Fecha = convertToDate(newObj.Fecha);
      }
      worksheet.addRow(newObj);
    });

    worksheet.eachRow({ includeEmpty: true }, function(row, rowNumber) {
      row.eachCell({ includeEmpty: true }, function(cell, colNumber) {
        if (columnsExcel[colNumber - 1] && (columnsExcel[colNumber - 1].key === 'Tratamiento' || columnsExcel[colNumber - 1].key === 'Fecha')) {
          cell.numFmt = 'dd/mm/yyyy';
        }
      });
    });


    // Guardar el archivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'Listado-pacientes.xlsx');
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitListado}>

          {loading ? (
                <div className="spinner-container">
                    <Spinner />
                </div>
            ) : (


          listadoResult?.length ? (
          <div className="listado-tabla-container">

            {/* <Table dataSource={listadoResult} columns={columns} /> */}
            <Table
              dataSource={listadoResult.map((item, index) => ({
                ...item,
                key: index // O utiliza una propiedad única de cada elemento si la tienes
              }))}
              columns={columns}
              scroll={{ x: 'max-content' }}
            />
            <div className="btn-dwnld">
                <CSVLink
                  filename={"Listado-completo.csv"}
                  data={listadoResult}
                  className="button is-link"
                  separator={"|"}
                >Descargar CSV</CSVLink>
                <button
                  className="button is-link"
                  onClick={exportToExcel}
                >
                  Descargar XLSX
                </button>
            </div>
          </div>
          ) : (
            <p>
              <i>Sin resultados</i>
            </p>
          )
        )}
        </form>
      </div>
      <div id='actions'>
        <button className='button is-link' form='formNewElement' type='submit'>
          Generar Listado
        </button>
      </div>
    </>
  );
}
